module.exports = __webpack_public_path__ + "cdda7384448ffeceb6cc746a74f33eb7.png";